// packages/shared/src/rules/economy.ts
import { tuning, type CatalogId, type FruitType } from '@whiskerton/content';
import { catalogLookup, type Lookup } from './lookup';

export function sellPrice(catalogId: CatalogId, town: { nativeFruit: FruitType }, lookup: Lookup = catalogLookup): number {
  const e = lookup(catalogId);
  if (!e || e.kind === 'world') return 0;
  if (e.kind === 'fruit') return e.fruit === town.nativeFruit ? tuning.shop.nativeFruitSell : tuning.shop.foreignFruitSell;
  return e.sell;
}
export function dropBoxPrice(catalogId: CatalogId, town: { nativeFruit: FruitType }, lookup: Lookup = catalogLookup): number {
  return Math.floor(sellPrice(catalogId, town, lookup) * tuning.shop.dropBoxRate);
}
